import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { HelpArticleTagResponse } from '@business/entities/helpArticle';
import { HelpArticleAPI } from '@business/api/helpArticle';

export class HelpArticleTagBloc extends BaseBloc {
  private readonly helpArticleTagRepo = new Repository<HelpArticleTagResponse>({
    getItemId: tag => tag.id,
  });

  readonly helpArticleTags$ = this.helpArticleTagRepo.items$;
  readonly selectHelpArticleTag = this.helpArticleTagRepo.selectItem;

  onReset() {
    this.helpArticleTagRepo.reset();
  }

  fetchHelpArticleTags = () => {
    return HelpArticleAPI.fetchHelpArticleTags().pipe(
      this.helpArticleTagRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_help_article_tags_error') }),
    );
  };

  createHelpArticleTag = (helpArticle: Partial<HelpArticleTagResponse>) => {
    return HelpArticleAPI.createHelpArticleTag(helpArticle).pipe(
      this.helpArticleTagRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_help_article_tag'),
      }),
    );
  };
}
